
import { getCriterionById } from "@/store";
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    item: {},
    row: {},
  },

  setup() {
    return {
      getCriterionById,
    };
  },
  // props: ["item", "row"],
});
